import AuthLayout from '@/components/layouts/AuthLayout.vue';
import PdsLayout from '@/pds/layouts/PdsLayout.vue';
import BoardView from '@/pds/views/BoardView.vue';
import LateOrdersView from '@/pds/views/LateOrdersView.vue';
import JournalView from '@/pds/views/JournalView.vue';
import OrderEditView from '@/pds/views/OrderEditView.vue';
import OperatorSwitchView from '@/pds/views/OperatorSwitchView.vue';
import OrderView from '@/pds/views/OrderView.vue';
import SearchView from '@/pds/views/SearchView.vue';
import PrinterSettingsView from '@/pds/views/PrinterSettingsView.vue';
import SettingsView from '@/pds/views/SettingsView.vue';
import StockOutView from '@/pds/views/StockOutView.vue';
import ToOrderView from '@/pds/views/ToOrderView.vue';
import { pinia } from '@/stores';
import { useAuthStore } from '@/stores/auth/auth.slice';
import LoginView from '@/views/LoginView.vue';
import RecovePasswordView from '@/views/RecovePasswordView.vue';
import SignupView from '@/views/SignupView.vue';
import { watch } from 'vue';
import {
  createRouter,
  createWebHistory,
  type NavigationGuardWithThis,
} from 'vue-router';

const isLogin: NavigationGuardWithThis<undefined> = async (to) => {
  const authStore = useAuthStore(pinia);
  if (authStore.connectStatus == 'loading') {
    await new Promise((res) => {
      const stop = watch(
        () => authStore.connectStatus,
        (status) => {
          if (status != 'loading') {
            stop();
            res(status);
          }
        },
      );
    });
  }
  if (authStore.connectStatus == 'connected') return true;
  else return { path: '/login', query: { redirect: to.fullPath } };
};

const isDisconnected: NavigationGuardWithThis<undefined> = async () => {
  const authStore = useAuthStore(pinia);
  if (authStore.connectStatus == 'loading') {
    await new Promise((res) => {
      const stop = watch(
        () => authStore.connectStatus,
        (status) => {
          if (status != 'loading') {
            stop();
            res(status);
          }
        },
      );
    });
  }
  if (authStore.connectStatus == 'disconnected') return true;
  else return { path: '/' };
};

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'root',
      component: PdsLayout,
      beforeEnter: isLogin,
      children: [
        { path: '', name: 'pds-board', component: BoardView },
        { path: 'retards', name: 'pds-late', component: LateOrdersView },
        { path: 'commande/:id', name: 'pds-order', component: OrderView },
        {
          path: 'commande/:id/modifier',
          name: 'pds-order-edit',
          component: OrderEditView,
        },
        { path: 'sortir', name: 'pds-stock-out', component: StockOutView },
        { path: 'commander', name: 'pds-to-order', component: ToOrderView },
        { path: 'recherche', name: 'pds-search', component: SearchView },
        { path: 'journal', name: 'pds-journal', component: JournalView },
        { path: 'reglages', name: 'pds-settings', component: SettingsView },
        {
          path: 'reglages/imprimante',
          name: 'pds-printer',
          component: PrinterSettingsView,
        },
        {
          path: 'operateur',
          name: 'pds-operator',
          component: OperatorSwitchView,
        },
      ],
    },
    {
      // Le lien des e-mails de nouvelle commande (`/order/<id>?action=accepted|rejected|viewed`), ouvert sur la fiche.
      path: '/order/:id',
      redirect: (to) => ({
        name: 'pds-order',
        params: { id: to.params.id },
        query: to.query,
      }),
    },
    {
      path: '/',
      name: 'auth',
      component: AuthLayout,
      beforeEnter: isDisconnected,
      children: [
        {
          path: 'login',
          component: LoginView,
          meta: { holdsWhenConnected: true },
        },
        {
          path: 'signup',
          component: SignupView,
        },
        {
          path: 'recove',
          component: RecovePasswordView,
        },
      ],
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
});

export default router;
